/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NormativeAccessLogScopeFilter } from './normativeAccessLogScopeFilter';


export interface NormativeAccessLogIncludeFilterItems { 
    relation?: NormativeAccessLogIncludeFilterItems.RelationEnum;
    scope?: NormativeAccessLogScopeFilter;
}
export namespace NormativeAccessLogIncludeFilterItems {
    export type RelationEnum = 'document' | 'version' | 'user';
    export const RelationEnum = {
        Document: 'document' as RelationEnum,
        Version: 'version' as RelationEnum,
        User: 'user' as RelationEnum
    };
}


